'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactTable = require('react-table');

var _reactTable2 = _interopRequireDefault(_reactTable);

var _FontIcon = require('material-ui/FontIcon');

var _FontIcon2 = _interopRequireDefault(_FontIcon);

var _reactRouterDom = require('react-router-dom');

require('react-table/react-table.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GenericMaterialAreasList = function (_React$Component) {
	_inherits(GenericMaterialAreasList, _React$Component);

	function GenericMaterialAreasList() {
		_classCallCheck(this, GenericMaterialAreasList);

		return _possibleConstructorReturn(this, (GenericMaterialAreasList.__proto__ || Object.getPrototypeOf(GenericMaterialAreasList)).apply(this, arguments));
	}

	_createClass(GenericMaterialAreasList, [{
		key: 'render',
		value: function render() {
			var data = this.props.genericMaterialAreas.map(function (tA) {
				return _extends({ _id: tA.id }, tA);
			});

			var columns = [{
				id: 'edit',
				width: 45,
				Cell: function Cell(col) {
					return _react2.default.createElement(
						_reactRouterDom.Link,
						{ to: '/genericmaterialareas/edit/' + col.original.id },
						_react2.default.createElement(
							_FontIcon2.default,
							{ className: 'material-icons' },
							'edit'
						)
					);
				}
			}, {
				id: 'copy',
				width: 45,
				Cell: function Cell(col) {
					return _react2.default.createElement(
						_reactRouterDom.Link,
						{ to: { pathname: '/genericmaterialareas/create', state: { contentTree: col.original.contentTree } } },
						_react2.default.createElement(
							_FontIcon2.default,
							{ className: 'material-icons' },
							'file_copy'
						)
					);
				}
			}, {
				Header: 'Nome',
				accessor: 'name',
				minWidth: 300
			}, {
				Header: 'Mensagem',
				accessor: 'message',
				minWidth: 300
			}, {
				Header: 'Destaque',
				accessor: 'featured',
				width: 100,
				Cell: function Cell(col) {
					return col.original.featured ? 'Sim' : 'Não';
				}
			}, {
				Header: 'Categoria',
				width: 100,
				Cell: function Cell(col) {
					var categoryType = void 0;

					if (col.original.category === 'VIDEO') {
						categoryType = 'Vídeo';
					} else if (col.original.category === 'MATERIAL') {
						categoryType = 'Material';
					} else if (col.original.category === 'COURSES') {
						categoryType = 'Curos';
					}

					return _react2.default.createElement(
						'span',
						null,
						categoryType
					);
				}
			}, {
				Header: 'Início',
				accessor: 'startDate',
				width: 100,
				Cell: function Cell(col) {
					return _react2.default.createElement(
						'span',
						null,
						(0, _moment2.default)(col.original.startDate).format('DD/MM/YYYY HH:mm')
					);
				}
			}, {
				Header: 'Fim',
				accessor: 'endDate',
				width: 100,
				Cell: function Cell(col) {
					return _react2.default.createElement(
						'span',
						null,
						col.original.endDate ? (0, _moment2.default)(col.original.endDate).format('DD/MM/YYYY HH:mm') : ''
					);
				}
			}, {
				Header: 'Modificada em',
				accessor: 'updatedAt',
				width: 100,
				Cell: function Cell(col) {
					return _react2.default.createElement(
						'span',
						null,
						(0, _moment2.default)(col.original.updatedAt).format('DD/MM/YYYY HH:mm')
					);
				}
			}];

			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(_reactTable2.default, {
					data: data,
					columns: columns,
					loading: this.props.loading,
					previousText: 'Anterior',
					nextText: 'Pr\xF3xima',
					loadingText: 'Carregando...',
					noDataText: 'N\xE3o foram encontradas \xE1reas de materiais gen\xE9ricos para este filtro',
					pageText: 'P\xE1gina',
					ofText: 'de',
					rowsText: 'linhas',
					showPaginationBottom: true,
					width: 100,
					defaultPageSize: 20
				})
			);
		}
	}]);

	return GenericMaterialAreasList;
}(_react2.default.Component);

exports.default = GenericMaterialAreasList;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/components/genericMaterialAreas/GenericMaterialAreasList.js
// module id = 3219
// module chunks = 0